import options from './options';

const root = {
	options
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js